// useBlockerActions.js — consome apolo:blockerAction (botões do turn_blocker no feed).
// Claim one-shot do nonce (Chat e Code podem montar o MESMO workspace — só um envia),
// guarda de run em voo (não atropela um turno ativo) e envio via handleSendRef.

import { useEffect } from 'react';
import { claimBlockerNonce } from '../../../lib/loop/blockerActions.js';
import { getRunSnapshot } from '../../../lib/agentRunStore.js';

export function useBlockerActions({ sessionId, handleSendRef }) {
  useEffect(() => {
    if (!sessionId) return undefined;
    const onAction = (e) => {
      const d = e?.detail || {};
      if (!d.prompt) return;
      if (getRunSnapshot(sessionId).running) return; // turno em voo: botão é de turno TERMINADO
      if (!claimBlockerNonce(d.nonce)) return;
      Promise.resolve(handleSendRef?.current?.({ text: d.prompt })).catch(() => {});
    };
    window.addEventListener('apolo:blockerAction', onAction);
    return () => window.removeEventListener('apolo:blockerAction', onAction);
  }, [sessionId, handleSendRef]);
}
